import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { inboxActions } from '../../../../../store/actions'
import moment from 'moment'
import { commons } from '../../../../../hook/common'

/*
   구매확인서 form
 */
const InboxForm1 = (props) => {
  useEffect(() => {}, [])

  return (
    <>
      <div className="detail-table-box" style={{ marginTop: '1rem' }}>
        <div className="detail-title">일반정보</div>
        <div className="detail-table-scroll">
          <ul className="flex-col infor-detail">
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="tit">공급자상호명</span>
                <span>
                  {props.data?.prodOrgNm} | {props.data?.prodOrgId}
                </span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="tit">구매자상호명</span>
                <span>
                  {props.data?.prchsNm} | {props.data?.brno}
                </span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="tit">총수량</span>
                <span>{props.data?.grcnt}</span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="tit">총금액</span>
                <span>{props.data?.gramt && commons.addComma(props.data?.gramt)}</span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="tit">구매확인번호</span>
                <span>{props.data?.prchsConfirmNo}</span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="tit">구매확인일자</span>
                <span>
                  {props.data?.prchsConfirmDt && moment(props.data?.prchsConfirmDt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD')}
                </span>
              </div>
            </li>
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="tit">구매확인기관명</span>
                <span>{props.data?.cfmOrgNm}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {props.data?.attachGroupId && (
        <div className="detail-table-box">
          <div className="detail-title">첨부파일</div>
          <div className="detail-table-scroll">
            <div className="inner">
              <div className="scroll">
                <div className="row">
                  {props.data?.attachList?.length > 0
                    ? props.data?.attachList.map((attach, index) => (
                        <ul key={index}>
                          <li className="col text">
                            <a href={'/portal/file/' + attach?.fileId} download title="파일다운로드">
                              {attach.originFileNm}
                            </a>
                          </li>
                        </ul>
                      ))
                    : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="detail-table-box">
        <div className="detail-title">발급이력</div>
        <div className="detail-table-scroll">
          <ul className="flex-col infor-detail">
            <li className="row w-100 item">
              <div className="flex-row w-full">
                <span className="title">발급일자</span>
                <span>{moment(props.data?.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD')}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const actionCreators = {
  getFile: inboxActions.getFile,
}

export default connect(mapStateToProps, actionCreators)(InboxForm1)
